import { render } from "./ConfigsList.vue?vue&type=template&id=4677a391"
import script from "./ConfigsList.vue?vue&type=script&lang=js"
export * from "./ConfigsList.vue?vue&type=script&lang=js"

import "./ConfigsList.vue?vue&type=style&index=0&id=4677a391&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__